export const DEFAULT_FILTERS_SEMAFOROS = {
  envasado: 0,
  idCategoria: null,
  idSucursal: null,
  razonSocial: "",
  idCliente: null,
  semaforo: "",
  fechaDesde: null,
  fechaHasta: null,
  soloConDeuda: false,
  ordenarPor: "RAZON_SOCIAL",
};
